/**
 * c24Defaults.js
 *
 * Version    : 1.0.0
 * Release    : 9-12-2015
 * License    : Copyright by Check24.de
 */
(function() {
    window._paq = window._paq || [];

    window.c24LpRoot = window.c24LpRoot || '/';
    window.c24MobileDevice = false;
    window.c24DeviceOutput = 'desktop';

    /**
     * Mobile Device Check
     */
    $(function() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
            window.c24MobileDevice = true;
        }
    });

    /**
     * On ready events
     */
    $(document).ready(function() {

        window.c24LpCssLoaded.then(function() {

            // Check if there is a root data field in body
            window.c24LpRoot = $('.div24Main').data('root') || window.c24LpRoot;

            /**
             * Fixed Column Heights
             */
            window.c24EqualColumns();

            /**
             * Do a fade rotator if .c24InfoRotator exist
             */
            $('.c24InfoRotator').each(function() {
                const rotator = $(this);
                const liElements = $('li', rotator);
                if (liElements.length) {
                    rotator.c24Randomize('li');
                    liElements.c24Rotator();
                }
            });

            /**
             * Accordion
             */
            if ($('.c24Accordion').length) {
                $('.c24Accordion').c24Accordion();
            }

            // Wraps a div around the tables
            $('.c24Editor table').wrap('<div class="c24TableScroll"></div>');

            /**
             * Smooth Anchor Scroller
             */
            $('a[href*="#"], area[href*="#"]').on('click',function (e) {
                let link = new URL($(this).attr('href'), window.location.protocol + '//' + window.location.host);
                if (
                    $(this).attr('href').indexOf('#') === 0 || // check if link is an anchor on this page
                link.pathname === window.location.pathname // or is the same page
                ) {
                // Open in new tab
                    if (e.ctrlKey) {
                        return;
                    }

                    if ($(this).parents('.c24Tabfield').length) {
                        e.preventDefault();
                    } else {
                        const target = this.hash;
                        const $target = $(target);

                        if ($target.length) {
                            e.preventDefault();

                            const top = $target.offset().top;
                            const scrollTop = window.c24.lp.initAnchorScroll.getScrollTop($target);

                            $('html, body').stop().animate({
                                'scrollTop': top,
                            }, 200, 'swing', function () {
                                window.location.hash = target;

                                if (top !== scrollTop) {
                                    $('html, body').scrollTop(scrollTop);
                                }
                            });
                        }
                    }
                }
            });

            /**
             * Fancy Box
             */
            $('.js24Fancy').fancybox({});

            /**
             * Logo slider
             */
            $('.c24Carousel').c24Carousel();

            /**
             * Start the tabs
             */
            if ($('.c24Tabfield').length) {
                $('.c24Tabfield').c24Tabs();
            }

            /**
             * Make a column clickable from href
             */
            if ($('.js24ColClick')) {
                $('.js24ColClick').parents('.div24Col').not('.div24ColLink').addClass('div24ColLink').on('click', function() {
                    const url = $(this).find('.js24ColClick').attr('href');
                    const blank = $(this).find('js24ColClick').attr('target') == '_blank';

                    // If link exists redirect
                    if (url) {
                    // If _paq is enabled do track!
                        if (window._paq) {
                            window.Matomo.getAsyncTracker().trackLink(url, 'link');
                        }

                        // Does the link handling
                        if (blank == true) {
                            window.open(url);
                        }
                        else {
                            window.location.href = url;
                        }
                    }
                });
            }

            /**
             * Remove elements that are desktop only
             */
            if ($('.c24MobileOnly').length) {
                $('.c24MobileOnly').remove();
            }

            /**
             * Ads c24Last class to the last cell of a table in the CKeditor
             */
            $('.c24Editor table td:last-child').addClass('c24Last');
            $('.c24Editor table td:first-child').addClass('c24First');
        });
    });
})();
